import React from 'react';
import { Section } from './ui/Section';
export function PainSection() {
  return <Section background="white" data-id="element-149">
      <p className="text-xl md:text-2xl italic text-[#2d3748] mb-6 font-medium" data-id="element-150">
        Sabes perfectamente de lo que hablo:
      </p>

      <div className="space-y-3 mb-8" data-id="element-151">
        <div className="flex items-start bg-red-50 border border-red-100 p-4 rounded-lg" data-id="element-152">
          <span className="text-xl mr-3 mt-0.5" data-id="element-153">😤</span>
          <span className="text-[#2d3748] font-medium" data-id="element-154">
            El berrinche incontrolable cuando quitas la tablet
          </span>
        </div>
        <div className="flex items-start bg-red-50 border border-red-100 p-4 rounded-lg" data-id="element-155">
          <span className="text-xl mr-3 mt-0.5" data-id="element-156">😶</span>
          <span className="text-[#2d3748] font-medium" data-id="element-157">
            La mirada ausente en la mesa, como si no estuviera contigo
          </span>
        </div>
        <div className="flex items-start bg-red-50 border border-red-100 p-4 rounded-lg" data-id="element-158">
          <span className="text-xl mr-3 mt-0.5" data-id="element-159">😠</span>
          <span className="text-[#2d3748] font-medium" data-id="element-160">
            La irritabilidad constante cuando no tiene pantalla
          </span>
        </div>
        <div className="flex items-start bg-red-50 border border-red-100 p-4 rounded-lg" data-id="element-161">
          <span className="text-xl mr-3 mt-0.5" data-id="element-162">💔</span>
          <span className="text-[#2d3748] font-medium" data-id="element-163">
            Esa sensación de que ya no conectas con él
          </span>
        </div>
      </div>

      <div className="bg-[#1e3a5f] text-white p-6 rounded-xl shadow-lg mb-6" data-id="element-164">
        <p className="text-base md:text-lg font-bold leading-relaxed" data-id="element-165">
          No es tu culpa. Estás compitiendo contra algoritmos diseñados por
          expertos para secuestrar la atención de tu hijo.
        </p>
      </div>

      <p className="text-[#2d3748] text-base md:text-lg leading-relaxed" data-id="element-166">
        Tu hijo no es el problema.{' '}
        <strong className="text-[#dc4a3d]" data-id="element-167">
          El problema es que no tienes un plan de desintoxicación digital.
        </strong>
      </p>
    </Section>;
}